export namespace Flow {

    export enum Mode {
        /**
         * Flow is in draft mode and not yet published.
         * Possible to send for testing purposes.
         */
        draft = 'draft',
        /**
         * Flow is published and can be used in production.
         */
        published = 'published',
    }

    export enum Action {
        /**
         * Sending Data to WhatsApp Flows Data Endpoint
         * Payload: Customizable JSON payload on data exchanges { [key:string]: any }
         */
        data_exchange = 'data_exchange',
        /**
         * Triggers the next screen with the payload as its input.
         */
        navigate = 'navigate',
        /**
         * Accepts the termination parameters upon completion of a Flow
         */
        complete = 'complete',
    }
}
